import React from 'react'
import { faAngleLeft, faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppBar, Toolbar, IconButton, Grid } from '@mui/material';

import MOBILE_SIDEPANEL_CLASSES from './mobileSidePanelClasses';

import { connect } from 'react-redux'

import { updateMobileView, clearMobileOfferForm, updateMobileOfferForm } from '../../../actions/mobileActions';
import ShiftDetails from './shiftDetails';
import PartialShift from './partialShift'
import SendTo from './sendTo';
import PrivateOffer from './privateOffer';
import Summary from './summary';
import Success from './success';
import ShiftPicker from './shiftsPicker';
import CommentToManager from './commentToManager';
import TimeOffRequestCreation from './timeOffRequestCreation';
import { RequestTypes, TorCreationType } from '../../../../Enums';

class SidePanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            current: {
                view: 'ShiftDetails',
                previous: ''
            }
        }
    }

    handlePreviousView = () => {
        const { current } = this.state;
        const { updateMobileView, mobileView, mobileOfferShiftForm, updateMobileOfferForm } = this.props;

        let newCurrent;
        const isPrivate = mobileOfferShiftForm.isPrivate;

        switch (current.previous) {
            case 'ShiftDetails':
                newCurrent = {
                    view: 'ShiftDetails',
                    previous: ''
                }
                break;
            case 'PartialShift':
                newCurrent = {
                    view: 'PartialShift',
                    previous: 'ShiftDetails'
                }
                break;
            case 'SendTo':
                const setting = mobileOfferShiftForm.managerSetting
                
                newCurrent = {
                    view: 'SendTo',
                    previous: (setting.type === RequestTypes.toCover || setting.type === RequestTypes.shiftSwap) && setting.isPartialShiftEnabled ? 'PartialShift' : 'ShiftDetails'
                }
                updateMobileOfferForm({ privateEmployeeSelected: [] });
                break;
            case 'PrivateOffer':
                newCurrent = {
                    view: 'PrivateOffer',
                    previous: 'SendTo'
                }
                break;
            case 'TimeOffRequestCreation':
                newCurrent = {
                    view: 'TimeOffRequestCreation',
                    previous: isPrivate ? 'PrivateOffer' : 'SendTo'
                }
                break;
            case 'Summary':
                const showTimeOffRequestView = setting.timeOffRequestCreationType === TorCreationType.Optional || setting.timeOffRequestCreationType === TorCreationType.Required;
                newCurrent = {
                    view: 'Summary',
                    previous: showTimeOffRequestView ? 'TimeOffRequestCreation' : isPrivate ? 'PrivateOffer' : 'SendTo'
                }
                break;
            case 'ShiftPicker':
                newCurrent = {
                    view: 'ShiftPicker',
                    previous: 'ShiftDetails'
                }
                break;
            case 'CommentToManager':
                newCurrent = {
                    view: 'CommentToManager',
                    previous: 'ShiftDetails'
                }
                break;
            default:
                updateMobileView(mobileView.previous)
                break;
        }

        this.setState({ current: newCurrent });
    }

    updateSidePanelView = (nextView) => {
        const { current } = this.state
        this.setState({
            current: {
                view: nextView,
                previous: current.view,
            }
        })
    }

    renderCurrentView = () => {
        const { current } = this.state;
        const { refreshData } = this.props;
        let view;

        switch (current.view) {
            case 'ShiftDetails':
                view = <ShiftDetails
                    updateSidePanelView={this.updateSidePanelView}
                    refreshData={refreshData}
                />
                break;
            case 'PartialShift':
                view = <PartialShift
                    handlePreviousView={this.handlePreviousView}
                    updateSidePanelView={this.updateSidePanelView}
                />
                break;
            case 'SendTo':
                view = <SendTo
                    handlePreviousView={this.handlePreviousView}
                    updateSidePanelView={this.updateSidePanelView}
                />
                break;
            case 'PrivateOffer':
                view = <PrivateOffer
                    handlePreviousView={this.handlePreviousView}
                    updateSidePanelView={this.updateSidePanelView}
                />
                break;
            case 'Summary':
                view = <Summary
                    handlePreviousView={this.handlePreviousView}
                    updateSidePanelView={this.updateSidePanelView}
                    refreshData={refreshData}
                />
                break;
            case 'Success':
                view = <Success
                    updateSidePanelView={this.updateSidePanelView}
                />
                break;
            case 'ShiftPicker':
                view = <ShiftPicker
                    handlePreviousView={this.handlePreviousView}
                    updateSidePanelView={this.updateSidePanelView}
                />
                break;
            case 'CommentToManager':
                view = <CommentToManager
                    handlePreviousView={this.handlePreviousView}
                    updateSidePanelView={this.updateSidePanelView}
                />
                break;
            case 'TimeOffRequestCreation':
                view = <TimeOffRequestCreation
                    handlePreviousView={this.handlePreviousView}
                    updateSidePanelView={this.updateSidePanelView}
                />
                break;
            default:
                view = <ShiftDetails
                    updateSidePanelView={this.updateSidePanelView}
                    refreshData={refreshData}
                />
                break;
        }

        return view;
    };
    render() {
        const { classes, mobileView, updateMobileView, clearMobileOfferForm, mobileOfferShiftForm } = this.props;

        return (
            <React.Fragment>
                <AppBar position="relative" className={classes.appbar}>
                    <Toolbar>
                        <Grid container alignItems={'center'}>
                            <Grid item xs={2}>
                                <IconButton onClick={this.handlePreviousView} size="large">
                                    <FontAwesomeIcon icon={faAngleLeft} style={{ color: '#333' }} />
                                </IconButton>
                            </Grid>
                            <Grid item xs={8}>
                                <div style={{ textAlign: 'center', width: '100%', fontWeight: 700 }}>{mobileOfferShiftForm?.managerSetting?.name}</div>
                            </Grid>
                            <Grid item xs={2} style={{ textAlign: 'right' }}>
                                <IconButton
                                    onClick={() => {
                                        updateMobileView(mobileView.previous)
                                        clearMobileOfferForm()
                                    }}
                                    size="large">
                                    <FontAwesomeIcon icon={faTimes} style={{ color: '#333' }} />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
                <div className={classes.contentWrapper}>
                    {this.renderCurrentView()}
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    classes: MOBILE_SIDEPANEL_CLASSES,
    mobileView: state.mobileView,
    mobileOfferShiftForm: state.mobileOfferShiftForm,
});

const mapDispatchToProps = (dispatch) => ({
    updateMobileView: payload => dispatch(updateMobileView(payload)),
    clearMobileOfferForm: () => dispatch(clearMobileOfferForm()),
    updateMobileOfferForm: payload => dispatch(updateMobileOfferForm(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SidePanel);
